import {all, fork, put, takeLatest} from 'redux-saga/effects';
import {
  addTicketAttachmentSuccess,
  commentTicketSuccess,
  createTicketSuccess,
  getAllTicketsSuccess,
  getTicketAttachmentSuccess,
  getTicketSuccess,
} from 'redux/actions/Support';
import {
  SUPPORT_ADD_ATTACHMENT,
  SUPPORT_ALL,
  SUPPORT_COMMENT,
  SUPPORT_CREATE,
  SUPPORT_GET,
  SUPPORT_GET_ATTACHMENT,
} from 'redux/constants/Support';
import EstService from 'services/EstService';

export function* getTickets() {
	yield takeLatest(SUPPORT_ALL, function* ({ perPage, page }) {
		try {
			const res = yield EstService.getTickets(perPage, page);
			yield put(getAllTicketsSuccess(res.data, res.total));
		} catch (err) {
			console.log(err);
		}
	});
}

export function* getTicket() {
	yield takeLatest(SUPPORT_GET, function* ({ id }) {
		try {
			const res = yield EstService.getTicket(id);
			yield put(getTicketSuccess(res.data));
		} catch (err) {
			console.log(err);
		}
	});
}

export function* createTicket() {
	yield takeLatest(SUPPORT_CREATE, function* ({ data, history }) {
		try {
			const res = yield EstService.createTicket(data);
			yield put(createTicketSuccess(res.data));
			history.push(`/app/support/${res.data.issue_id}`);
		} catch (err) {
			console.log(err);
		}
	});
}

export function* commentTicket() {
	yield takeLatest(SUPPORT_COMMENT, function* ({ id, comment }) {
		try {
			yield EstService.commentTicket(id, comment);
			yield put(commentTicketSuccess(comment));
		} catch (err) {
			console.log(err);
		}
	});
}

export function* addTicketAttachment() {
	yield takeLatest(SUPPORT_ADD_ATTACHMENT, function* ({ id, attachment }) {
		try {
			yield EstService.addTicketAttachment(id, attachment);
			yield put(addTicketAttachmentSuccess(attachment));
		} catch (err) {
			console.log(err);
		}
	});
}

export function* getTicketAttachment() {
	yield takeLatest(SUPPORT_GET_ATTACHMENT, function* ({ id }) {
		try {
			const res = yield EstService.getTicketAttachment(id);
			yield put(getTicketAttachmentSuccess(res.data));
		} catch (err) {
			console.log(err);
		}
	});
}

export default function* supportSaga() {
	yield all([fork(getTickets)]);
	yield all([fork(getTicket)]);
	yield all([fork(createTicket)]);
	yield all([fork(commentTicket)]);
	yield all([fork(addTicketAttachment)]);
	yield all([fork(getTicketAttachment)]);
}
